<template>
  <div class="zxxy">
    <div class="common_title clearfix">
      <div class="icon"><i class="icons i1"></i></div><p>主席序言</p>
    </div>
    <div class="bjlsc_detail">
      <div class='clearfix'>
        <div class="img_wrap">
          <img :src="domain+data.litpic" alt="" v-if='data.litpic'>
          <p class="name">{{data.seotitle}}</p>
          <p v-html='data.keywords'></p>
        </div>
        <div class="text_wrap">
          <p class="title EY_BoldItalic">{{data.description}}</p> 
          <div class="text_wrap_detail" v-html='data.content'>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'zxxy',
  data () {
    return {
      data: '',
      domain:'https://eympe.vapps.me'

    }
  },
  mounted:function(){
     this.$http.post('https://eympe.vapps.me/index.php?g=Index&m=Index&a=get_category',
       {
          cid:1
        },
       {emulateJSON : true})
   .then((response) => {
         this.data=response.body.cate
         console.log(response)
         this.data.keywords=htmlDecodeByRegExp(this.data.keywords)

         function htmlDecodeByRegExp(str){  
               var s = "";
               if(str.length == 0) return "";
               s = str.replace(/&amp;/g,"&");
               s = s.replace(/&lt;/g,"<");
               s = s.replace(/&gt;/g,">");
               s = s.replace(/&nbsp;/g," ");
               s = s.replace(/&#39;/g,"\'");
               s = s.replace(/&quot;/g,"\"");
               return s;  
         }
     })
  }
}
</script>

<style scoped>
  i.i1{
    width: 0.39rem;
    height: 0.39rem;
    background-position: -0.82rem -1.45rem;
  }
   .bjlsc_detail{
    padding: 0 0.36rem;
    
  }
  .img_wrap{
    float: left;
    width: 1.7rem;
  }
  .img_wrap img{
    width: 0.97rem;
    display: block;
    margin-bottom: 0.1rem;
  }
  .img_wrap p{
    font-size: 0.2rem;
    color: #6d6e71;
  }
  .img_wrap p.name{
    font-weight: bold;
  }
  .text_wrap{
    width: 3.66rem;
    float: right
  }
  .bjlsc_detail>div{
    padding-right: 0.14rem;
    background-color: #fff;
  }
  .text_wrap .title{
    font-size: 0.2rem;
    color: #000;
    font-style: italic;
    margin-bottom: 0.06rem;
  }
  .text_wrap_detail{
    font-size: 0.2rem;
    color: #060606;
  }
</style>


// WEBPACK FOOTER //
// src/components/zxxy.vue